/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RegistrazioneResDto } from '../../models/registrazione-res-dto';
import { UpdateRegistrazioneDto } from '../../models/update-registrazione-dto';

export interface RegistrazioniControllerUpdateOrganizzazione$Params {
  idRegistrazione: number;
  body: UpdateRegistrazioneDto;
}

export function registrazioniControllerUpdateOrganizzazione(
  http: HttpClient,
  rootUrl: string,
  params: RegistrazioniControllerUpdateOrganizzazione$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<RegistrazioneResDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    registrazioniControllerUpdateOrganizzazione.PATH,
    'patch',
  );
  if (params) {
    rb.path('idRegistrazione', params.idRegistrazione, {});
    rb.body(params.body, 'application/json');
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RegistrazioneResDto>;
      }),
    );
}

registrazioniControllerUpdateOrganizzazione.PATH =
  '/admin/registrazione/id/{idRegistrazione}';
